export type SortKey = "latest" | "views" | "rating";

const OPTIONS: { key: SortKey; label: string; icon: string }[] = [
  { key: "latest", label: "最新上架", icon: "ri-time-line" },
  { key: "views", label: "最多浏览", icon: "ri-fire-line" },
  { key: "rating", label: "评分最高", icon: "ri-star-line" },
];

interface SortTabsProps {
  value: SortKey;
  onChange: (key: SortKey) => void;
}

export default function SortTabs({ value, onChange }: SortTabsProps) {
  return (
    <div className="inline-flex items-center gap-1 bg-background-900 border border-background-800 rounded-full p-1">
      {OPTIONS.map((opt) => (
        <button
          key={opt.key}
          type="button"
          onClick={() => onChange(opt.key)}
          className={`flex items-center gap-1.5 px-3 md:px-4 py-2 rounded-full text-xs md:text-sm font-label transition-colors cursor-pointer whitespace-nowrap ${
            value === opt.key
              ? "bg-primary-600 text-background-50"
              : "text-foreground-300 hover:text-accent-400"
          }`}
        >
          <i className={opt.icon} />
          {opt.label}
        </button>
      ))}
    </div>
  );
}